import Swiper from 'swiper';

const relatedProductsSlider = new Swiper('.related-products__items', {
  loop: false,
  slidesPerView: 1.1,
  spaceBetween: 20,
  breakpoints: {
    540: {
      slidesPerView: 1.5,
    },
    740: {
      slidesPerView: 2,
    },
    1100: {
      slidesPerView: 3,
    },
  },
});
